export default __webpack_public_path__ + "static/media/sticker-E.d193b5e3.png";